module.exports = __webpack_public_path__ + "components/country-flag/static/om-c0aee33b3ab3397aeddb94e236d0eaa4.svg";